import React from 'react';
import { Redirect, useParams, useLocation, useHistory } from 'react-router-dom';
import { Loader } from '@bambuser-ui';
import { connect } from 'react-redux';

import * as ROUTES from '../../constants/routes.js';
import withLandingRedirect from 'components/OrgSelector/withLandingRedirect.jsx';
import useOrganizations from 'hooks/useOrganizations.js';
import usePermissions from 'hooks/usePermissions.jsx';

import StatsPageTabOptions from 'constants/showStatsPageTabOptions.js';
import CallStatsPageTabOptions from '../../pages/StatsDetails/CallsStats/PageTabOptions.js';
import NotFoundPage from 'pages/NotFound/index.jsx';
import { PERMISSIONS } from 'shared-permissions';
const { CALL_STATS } = PERMISSIONS;

const Profile = ({ orgId }) => {
  const history = useHistory();
  const route = ROUTES.ORG_USER_PROFILE.replace(ROUTES.ONE_TO_ANY, orgId);

  history.replace(route);
  return null;
};

const Shows = ({ orgId }) => {
  const history = useHistory();
  const location = useLocation();
  history.replace(`/${orgId}${location.pathname}`);
  return null;
};

const Show = ({ orgId }) => {
  const history = useHistory();
  const location = useLocation();
  history.replace(`/${orgId}${location.pathname}`);
  return null;
};

const Users = ({ orgId }) => {
  const history = useHistory();
  const location = useLocation();
  history.replace(`/${orgId}${location.pathname}`);
  return null;
};

export const ProfileShortcut = withLandingRedirect(Profile);
export const ShowsShortcut = withLandingRedirect(Shows);
export const ShowShortcut = withLandingRedirect(Show);
export const UsersShortcut = withLandingRedirect(Users);
